'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z' });

var Folder = function Folder(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Folder = (0, _pure2.default)(Folder);
Folder.muiName = 'SvgIcon';

exports.default = Folder;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Folder.js
// module id = 2419
// module chunks = 0